import { ArtworkMetadata } from "../business-types";

import { RESERVED_METADATA_KEYS } from "./config";
import { MetadataEnv } from "./types";

export function resolveValueFromMetadataEnv(
  metadataEnv: MetadataEnv,
  key: string
): string | undefined {
  switch (key as (typeof RESERVED_METADATA_KEYS)[number]) {
    case "Artist":
      return metadataEnv?.artist?.displayName ?? undefined;
    case "Collection":
      return metadataEnv?.collection?.title ?? undefined;
    case "No. Editions":
      return metadataEnv?.datumArtwork?.numEditions != null
        ? metadataEnv.datumArtwork.numEditions.toString()
        : undefined;
    default:
      return undefined;
  }
}

/** Fill in the blanks in `ArtworkMetadata` using `MetadataEnv` */
export function resolveArtworkMetadata(
  artworkMetadata: ArtworkMetadata,
  {
    metadataEnv,
    replaceNullishValueBy,
    replaceFalsyValueBy,
  }: {
    metadataEnv: MetadataEnv;
    replaceNullishValueBy?: string;
    replaceFalsyValueBy?: string;
  }
): ArtworkMetadata {
  const result: ArtworkMetadata = { entries: [] };

  for (const entry of artworkMetadata.entries) {
    const isEntrySpecial =
      ([...RESERVED_METADATA_KEYS] as string[]).includes(entry.key) &&
      entry.value === "";

    if (!isEntrySpecial) {
      result.entries.push(entry);
      continue;
    }

    const resolvedValue = resolveValueFromMetadataEnv(metadataEnv, entry.key);
    if (resolvedValue == null) {
      replaceNullishValueBy != null &&
        result.entries.push({ key: entry.key, value: replaceNullishValueBy });
      continue;
    }

    if (!resolvedValue) {
      result.entries.push({
        key: entry.key,
        value: replaceFalsyValueBy ?? resolvedValue,
      });
      continue;
    }

    result.entries.push({ key: entry.key, value: resolvedValue });
    continue;
  }
  return result;
}
